var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-month--row weeks"},_vm._l((_vm.SHORT_DAYS),function(day){return _c('div',{key:day,staticClass:"calendar-month--cell pa-2 text-center font-weight-bold caption"},[_vm._v(_vm._s(day))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }